import { render } from "./DemoTransfers.vue?vue&type=template&id=518e3a4a&scoped=true"
import script from "./DemoTransfers.vue?vue&type=script&lang=js"
export * from "./DemoTransfers.vue?vue&type=script&lang=js"

import "./DemoTransfers.vue?vue&type=style&index=0&id=518e3a4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518e3a4a"]])

export default __exports__